import { DestroyRef, Directive, inject, TemplateRef } from '@angular/core';
import { DetailDrawerFrame } from './detail-drawer-frame.service';

/**
 * Marks the item's title block for the drawer to show below its trail, above the item's tabs:
 *
 * ```html
 * <ng-template lpDetailDrawerHeading><h2>{{ titel() }}</h2></ng-template>
 * ```
 *
 * Only for an item with tabs — see {@link DetailDrawerTabsDirective}. Without them, the title opens
 * the item's content instead, where it scrolls away rather than holding the header's room for good.
 *
 * The template keeps the item's own bindings and styles; only where it renders moves.
 */
@Directive({ selector: 'ng-template[lpDetailDrawerHeading]' })
export class DetailDrawerHeadingDirective {
  private readonly frame = inject(DetailDrawerFrame);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);

  constructor() {
    this.frame.showHeading(this.templateRef);
    inject(DestroyRef).onDestroy(() => this.frame.clearHeading(this.templateRef));
  }
}
